import axiosInstance from '@/lib/api/client.ts';
import { PaymentMethod } from '@/lib/payment-methods/payment-method.ts';

export const addCreditCard = async (data: {
  token: string;
  paymentMethodId?: string;
  issuerId?: string;
  deviceSessionId?: string;
  idempotencyKey?: string;
}): Promise<void> => {
  await axiosInstance.post(`/payment-methods`, data);
};

/**
 * Removes non-digit characters from a string
 */
export function sanitizeCardNumber(cardNumber: string): number {
  return parseInt(cardNumber.replace(/\D/g, ''));
}

export async function getPaymentMethods(): Promise<PaymentMethod[]> {
  const { data } = await axiosInstance.get<{ cards: PaymentMethod[] }>('/payment-methods');
  return data.cards;
}

export async function deletePaymentMethod(id: string): Promise<void> {
  await axiosInstance.delete(`/payment-methods/${id}`);
}
